import { Close } from "@mui/icons-material";
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  IconButton,
  Typography,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import React from "react";
import LoadingButton from "../../elements/LoadingButton";

const ConfirmDialog = ({
  open = false,
  title = "",
  content = "",
  type = "primary",
  onClose = () => {},
  onClik = () => {},
  loading = false,
}) => {
  const classes = useStyles({ type });
  return (
    <>
      <Dialog onClose={onClose} open={open}>
        <Box
          bgcolor={`${type}.light`}
          color={`${type}.contrastText`}
          className={classes.headerView}
        >
          <Typography variant="h6">{title}</Typography>
          <IconButton onClick={onClose}>
            <Close />
          </IconButton>
        </Box>
        <DialogContent dividers>
          <Typography gutterBottom>{content}</Typography>
        </DialogContent>
        <Box className={classes.footerView}>
          <Button color={type} variant="outlined" onClick={onClose}>
            Cancel
          </Button>
          <LoadingButton
            loading={loading}
            color={type}
            autoFocus
            onClick={onClik}
            label="Confirm"
          />
        </Box>
      </Dialog>
    </>
  );
};

export default ConfirmDialog;

const useStyles = makeStyles((theme) => {
  return {
    headerView: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      padding: theme.spacing(1, 3),
      "& button": {
        color: "inherit",
      },
    },
    footerView: {
      padding: theme.spacing(1.5),
      display: "flex",
      justifyContent: "flex-end",
      gridGap: "12px",
    },
  };
});
